import React from 'react';
import { COLORS } from '../config/constants';

const RecentActivitiesList = ({ activities = [] }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'production': return '🛠️';
      case 'stock': return '📦';
      case 'project': return '📁';
      case 'shipment': return '🚚';
      case 'user': return '👤';
      case 'system': return '⚙️';
      default: return '•';
    }
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);

      if (diffMins < 1) return 'Şimdi';
      if (diffMins < 60) return `${diffMins} dakika önce`;
      if (diffHours < 24) return `${diffHours} saat önce`;
      if (diffDays < 7) return `${diffDays} gün önce`;
      return date.toLocaleDateString('tr-TR');
    } catch {
      return '';
    }
  };

  if (activities.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '3rem', color: COLORS.textLight }}>
        <p>Henüz aktivite bulunmuyor</p>
      </div>
    );
  }

  return (
    <div data-testid="recent-activities-list" style={{ maxHeight: '400px', overflowY: 'auto' }}>
      {activities.map((activity, index) => (
        <div
          key={activity.id || index}
          style={{
            padding: '1rem',
            borderBottom: index < activities.length - 1 ? `1px solid ${COLORS.background}` : 'none',
            display: 'flex',
            gap: '1rem',
            transition: 'background 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = COLORS.background}
          onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
        >
          <div
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '8px',
              background: `${COLORS.primary}15`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              fontSize: '1.25rem'
            }}
          >
            {getActivityIcon(activity.type)}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ color: COLORS.text, fontSize: '0.9rem', margin: 0, marginBottom: '0.25rem' }}>
              {activity.description}
            </p>
            <p style={{ color: COLORS.textLight, fontSize: '0.8rem', margin: 0 }}>
              {formatDate(activity.timestamp)}
              {activity.user && ` • ${activity.user}`}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecentActivitiesList;